import { render, staticRenderFns } from "./BottomBtn.vue?vue&type=template&id=1dc247c0&"
import script from "./BottomBtn.vue?vue&type=script&lang=js&"
export * from "./BottomBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports